module.exports = __webpack_public_path__ + "assets/img/paperwalletemptyB.e8e5c4b6e2430412cb97882f41e1ccb2.svg";